<template>
  <div ref="display">
    <!-- <test :list="list" :product-list="productList" /> -->
  </div>
</template>

<script>
import Vue from 'vue'
import { getActivityInfoApi } from '@/api/activity'
import { getProductDetailList } from '@/api/product'
// import test from './test.vue'
// import { vueCode } from './test'

export default {
  name: 'ActivityWx',
  // components: { test },
  data() {
    return {
      code: '',
      list: [],
      productList: [],
      component: null,
      html: '',
      js: '',
      css: ''
    }
  },
  watch: {
    // async code() {
    //   this.destroyCode()
    //   this.renderCode()
    // }
  },
  mounted() {
    const app = document.getElementById('app')
    app.style.zoom = 1

    const id = this.$route.query.id
    this.getActivityInfo(id)
  },
  beforeDestroy() {
    this.destroyCode()
  },
  methods: {
    async getActivityInfo(id) {
      const res = await getActivityInfoApi(id)
      if (!res.data) {
        this.list = []
        this.productList = []
        this.$Message.error('活动未开始或已结束')
        // eslint-disable-line
        wx.miniProgram.navigateBack()
        return
      }
      this.list = res.data.topicGroupList
      const ids = []
      this.list.forEach(item => {
        if (item.type === 1) {
          item.groupContents.forEach(product => {
            ids.push(product.contentId)
          })
        }
      })
      const result = await getProductDetailList({ ids })
      this.productList = result.data
      this.code = res.data.topicContentList[0]['content']
      // this.code = vueCode
      this.destroyCode()
      this.renderCode()
    },
    goDetail(id) {
      // eslint-disable-line
      wx.miniProgram.navigateTo({
        url: '/pages/product/product?id=' + id
      })
    },
    randomStr(len = 32) {
      const $chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'
      const maxPos = $chars.length
      let str = ''
      for (let i = 0; i < len; i++) {
        str += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return str
    },
    renderCode() {
      this.splitCode()

      if (this.html !== '' && this.js !== '') {
        const parseStrToFunc = new Function(this.js)()

        parseStrToFunc.template = this.html
        parseStrToFunc.methods.goDetail = this.goDetail
        const Component = Vue.extend(parseStrToFunc)
        this.component = new Component({
          propsData: {
            // list: this.list,
            // productList: this.productList
            list: this.productList
          }
        }).$mount()

        this.$refs.display.appendChild(this.component.$el)
        if (this.css !== '') {
          const style = document.createElement('style')
          style.type = 'text/css'
          style.id = this.randomStr()
          style.innerHTML = this.css
          document.getElementsByTagName('head')[0].appendChild(style)
        }
      }
    },
    getSource(source, type) {
      const regex = new RegExp(`<${type}[^>]*>`)
      let openingTag = source.match(regex)

      if (!openingTag) return ''
      else openingTag = openingTag[0]

      return source.slice(source.indexOf(openingTag) + openingTag.length, source.lastIndexOf(`</${type}>`))
    },
    splitCode() {
      const script = this.getSource(this.code, 'script').replace(/export default/, 'return ')
      const style = this.getSource(this.code, 'style')
      const template = '<div>' + this.getSource(this.code, 'template') + '</div>'

      this.js = script
      this.css = style
      this.html = template
    },
    destroyCode() {
      const $target = document.getElementById(this.id)
      if ($target) $target.parentNode.removeChild($target)

      if (this.component) {
        this.$refs.display.removeChild(this.component.$el)
        this.component.$destroy()
        this.component = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
